import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { completeSignIn } from '../lib/auth'

export default function Callback() {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    completeSignIn()
      .then(() => navigate('/', { replace: true }))
      .catch(err => setError(err instanceof Error ? err.message : String(err)))
  }, [navigate])

  return (
    <div className="h-full grid place-items-center text-slate-600">
      {error ? (
        <div className="max-w-md text-center">
          <div className="text-red-600 font-medium mb-2">Sign-in failed</div>
          <div className="text-sm text-slate-500">{error}</div>
        </div>
      ) : (
        <div>Completing sign-in…</div>
      )}
    </div>
  )
}
